// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JReT","rootNoMargin":"styles_rootNoMargin__hOmcM"};